<template>
  <div style="height: 100%" :key="selectedProject">
    <v-card class="d-flex flex-column" min-height="100%">
      <v-card-title class="pa-0">
        <v-col cols="12" class="pa-0">
          <div class="kpi-header pa-4">
            <div class="d-flex align-center">
              <span class="text-h6">Key Performance Indicator</span>
              <v-spacer></v-spacer>
            </div>

            <v-tabs
              v-model="employeeTabs"
              show-arrows
              background-color="transparent"
              class="kpi-tabs"
            >
              <v-tab
                v-for="(type, index) in kpiTypes"
                :key="type.KPI_Type_ID || index"
                class="text-subtitle-2"
              >
                {{ type.KPI_Type }}
              </v-tab>
            </v-tabs>
          </div>
        </v-col>
      </v-card-title>

      <v-card-text class="pa-0">
        <v-tabs-items
          v-model="employeeTabs"
          class="kpi-tabs-items"
          :touchless="true"
        >
          <v-tab-item
            v-for="(type, index) in kpiTypes"
            :key="type.KPI_Type_ID || index"
          >
            <component
              :is="getComponentName(type.KPI_Type)"
              v-model="employee"
              :kpiType="type.KPI_Type"
            />
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'MetricsEmployeeProjectsKPI',
  components: {
    HumanResources: () => import('@/components/kpi/kpi_tabs/HumanResourcesKPI.vue')
  },
  data () {
    return {
      employeeTabs: 0,
      kpiTypes: [],
      employee: null,
      selectedProject: null
    }
  },
  mounted () {
    this.getKpiTypes()
  },
  methods: {
    async getKpiTypes () {
      try {
        const res = await this.axios.get('/api/kpi_types', {
          headers: { Authorization: 'Bearer ' + (this.user?.token || '') }
        })
        this.kpiTypes = res.data || []
      } catch (err) {
        this.$store.dispatch('setError', {
          errorMsg: err.message + ' - ' + (err.response?.data || '')
        })
      }
    },
    getComponentName (typeName) {
      switch (typeName?.toUpperCase()) {
        case 'HUMAN RESOURCES':
          return 'HumanResources'
        default:
          return 'div'
      }
    }
  },
  computed: {
    user () {
      return this.$store.getters.getUser || {}
    }
  }
}
</script>

<style scoped>
.kpi-header {
  margin: 0;
  padding-bottom: 0;
}

.kpi-tabs {
  margin: 0;
  padding: 0;
}

.kpi-tabs-items,
.kpi-tabs-items .v-window,
.kpi-tabs-items .v-window__container,
.kpi-tabs-items .v-window-item {
  margin: 0 !important;
  padding: 0 !important;
  min-height: 0;
}

.kpi-tabs-items > .v-window-item > * {
  margin-top: 0 !important;
  padding-top: 0 !important;
}

.kpi-tabs .v-tab {
  min-width: auto;
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 8px;
  padding-bottom: 8px;
}
</style>
